import type { DisplayLayout } from './display-layout'

/*
 * 蓝皮肤时钟是 HiPro 专供：顶栏标语、右下角报名状态与公告只在这套里出现。
 * 电视降级包也引用本文件，不能引入 zod。
 */
export function hasDisplayClockExtras(
  layout: Pick<DisplayLayout, 'composition' | 'clockSkin'>,
): boolean {
  return layout.composition === 'clock' && layout.clockSkin === 'blue'
}

export const displayClockSlogan = '禁止赌博 仅供娱乐'
export const displayNoticeMaxLength = 200
export const defaultDisplayNotice =
  '🏆 前 3 名 - 奖励一张门票\n🎁 前 4 名 - 奖励积分 8 - 4 - 2 - 1'
